export type SkillCategory = "language" | "framework" | "styling" | "tool";

export interface SkillEntry {
  id: string;
  category: SkillCategory;
  iconName: string;
}

export const skills: SkillEntry[] = [
  { id: "javascript", category: "language", iconName: "SiJavascript" },
  { id: "typescript", category: "language", iconName: "SiTypescript" },
  { id: "java", category: "language", iconName: "SiOpenjdk" },
  { id: "php", category: "language", iconName: "SiPhp" },

  { id: "react", category: "framework", iconName: "SiReact" },
  { id: "nextjs", category: "framework", iconName: "SiNextdotjs" },
  { id: "svelte", category: "framework", iconName: "SiSvelte" },
  { id: "redux", category: "framework", iconName: "SiRedux" },
  { id: "lit", category: "framework", iconName: "SiLit" },
  { id: "jquery", category: "framework", iconName: "SiJquery" },

  { id: "tailwindcss", category: "styling", iconName: "SiTailwindcss" },

  { id: "git", category: "tool", iconName: "SiGit" },
  { id: "mysql", category: "tool", iconName: "SiMysql" },
  { id: "storybook", category: "tool", iconName: "SiStorybook" },
];
